// extracted by mini-css-extract-plugin
export default {"body":"CancellingLessons_body__edFO9","history":"CancellingLessons_history__DtTSe","footer":"CancellingLessons_footer__QdFAN"};